import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl: string = 'https://oscemediko.id/api-timer/api/master/';

  constructor(private http: HttpClient) {}

  
  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  /**
   * Perform a login request.
   *
   * @param credentials - The object containing credentials: `username` and `password`.
   * @returns A promise that resolves to the user object if the login is successful.
   * @throws An {@link HttpErrorResponse} if the login fails.
   */
  login(credentials: { USERNAME: string, PASSWORD: string }): Promise<any> {
    const url = `${this.baseUrl}user/login`;

    return this.http.post<any>(url, credentials).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  generateQR(credentials: { user_id: string }): Promise<any> {
    const url = `${this.baseUrl}user/qr/login`;

    return this.http.post<any>(url, credentials).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  checkQR(credentials: { token: string }): Promise<any> {
    const url = `${this.baseUrl}user/qr/check`;

    return this.http.post<any>(url, credentials).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  loginWithToken(data: any): Promise<any> {
    const url = `${this.baseUrl}user/auth`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }


  logout(data:any): Promise<any> {
    const url = `${this.baseUrl}user/logout`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  forgotPassword(data:any): Promise<any> {
    const url = `${this.baseUrl}user/forgot/password`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  resetPassword(data:any): Promise<any> {
    const url = `${this.baseUrl}user/reset/password`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getUsers(): Promise<any> {
    const url = `${this.baseUrl}user/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getUserById(data:any): Promise<any> {
    const url = `${this.baseUrl}user/get/by_id`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getAccessRoles(): Promise<any> {
    const url = `${this.baseUrl}user/access/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  editUser(user: any): Promise<any> {
    const url = `${this.baseUrl}user/edit`;

    return this.http.post<any>(url, user).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteUserDevice(data: any): Promise<any> {
    const url = `${this.baseUrl}user/device/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  registerUser(user: any): Promise<any> {
    const url = `${this.baseUrl}user/register`;

    return this.http.post<any>(url, user).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addSection(data: any): Promise<any> {
    const url = `${this.baseUrl}stasiun/save`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  updateSection(data: any): Promise<any> {
    const url = `${this.baseUrl}stasiun/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteUser(data: any): Promise<any> {
    const url = `${this.baseUrl}user/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteSection(data: any): Promise<any> {
    const url = `${this.baseUrl}stasiun/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }


  getSections($user_id : string): Promise<any> {
    const url = `${this.baseUrl}stasiun/get?ID_USER=${encodeURIComponent($user_id)}`;

    return this.http.get<any>(url).toPromise()
    .catch(this.handleError); // handle error (optional)
  }

  getCategories(): Promise<any> {
    const url = `${this.baseUrl}admin/kategori/get`;

    return this.http.get<any>(url).toPromise()
    .catch(this.handleError); // handle error (optional)
  }

  getCategoriesActive(): Promise<any> {
    const url = `${this.baseUrl}admin/kategori/get/aktif`;

    return this.http.get<any>(url).toPromise()
    .catch(this.handleError); // handle error (optional)
  }

  addCategory(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/kategori/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  editCategory(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/kategori/edit`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getOsceResult(): Promise<any> {
    const url = `${this.baseUrl}admin/osce/report/admin/get`;

    return this.http.get<any>(url).toPromise()
    .catch(this.handleError); // handle error (optional)
  }

  deleteOsceResult(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/report/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }
  detailOsceResult(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/report/select/detail`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addOSCE(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  updateOSCE(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteOSCE(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getOsceDetail(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/get/detail`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  updateOsceDetail(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/update/detail`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addOsceDetail(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/add/detail`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteOsceDetail(data: any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/delete/detail`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getOsce(): Promise<any> {
    const url = `${this.baseUrl}admin/osce/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getOsceTitle(data:any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/get/title`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  searchOsceTitle(data:any): Promise<any> {
    const url = `${this.baseUrl}admin/osce/search/title`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addTutorReport(data:any): Promise<any> {
    const url = `${this.baseUrl}tutor/osce/input/report`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getSection(data:any): Promise<any> {
    const url = `${this.baseUrl}stasiun/get/user`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addFormField(data:any): Promise<any> {
    const url = `${this.baseUrl}form/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  updateFormField(data:any): Promise<any> {
    const url = `${this.baseUrl}form/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteFormField(data:any): Promise<any> {
    const url = `${this.baseUrl}form/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getFormField(): Promise<any> {
    const url = `${this.baseUrl}form/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getFormCases(): Promise<any> {
    const url = `${this.baseUrl}form/case/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addFormCases(data:any): Promise<any> {
    const url = `${this.baseUrl}form/case/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  updateFormCases(data:any): Promise<any> {
    const url = `${this.baseUrl}form/case/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  deleteFormCases(data:any): Promise<any> {
    const url = `${this.baseUrl}form/case/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  addFormDetails(data:any): Promise<any> {
    const url = `${this.baseUrl}form/case/details/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError); // handle error (optional)
  }

  getFormDetails(form_case_id: number, page?: number, excluded_ids?: number[]): Promise<any> {
    let params = new HttpParams().set('form_case_id', form_case_id.toString());

    if (page) {
      params = params.set('page', page.toString());
    }

    // API expects excluded_ids as a single array parameter, not repeated params
    if (excluded_ids && excluded_ids.length > 0) {
      params = params.set('excluded_ids', JSON.stringify(excluded_ids));
    }

    return this.http.get<any>(`${this.baseUrl}form/case/details`, { params }).toPromise()
      .catch(this.handleError);
  }

  updateFormDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}form/case/details/update`, data).toPromise()
      .catch(this.handleError);
  }

  deleteFormDetails(id: number): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}form/case/details/delete`, { id }).toPromise()
      .catch(this.handleError);
  }
  getFormDetailsInfo(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}form/case/details/info`, data ).toPromise()
      .catch(this.handleError);
  }

  addFormDetailsAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}form/case/details/answer/add`, data ).toPromise()
      .catch(this.handleError);
  }

  getFormDetailsAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}form/case/details/answer/get`, data ).toPromise()
      .catch(this.handleError);
  }

  getToturReport(fullname: string): Promise<any> {
    const url = `${this.baseUrl}admin/osce/report/get/${encodeURIComponent(fullname)}`;
    return this.http.get<any>(url)
    .toPromise()
    .catch(this.handleError);
  }

  addPackageSimulation(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/package/add`, data ).toPromise()
      .catch(this.handleError);
  }

  updateSheetPackageSimulation(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/package/sheet/update`, data ).toPromise()
      .catch(this.handleError);
  }

  getPackageSimulation(): Promise<any> {
    return this.http.get<any>(`${this.baseUrl}simulation/package/get` ).toPromise()
      .catch(this.handleError);
  }

  updatePackageSimulation(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/package/update`, data ).toPromise()
      .catch(this.handleError);
  }

  deletePackageSimulation(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/package/delete`, data ).toPromise()
      .catch(this.handleError);
  }

  simulationJoin(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/join`, data ).toPromise()
      .catch(this.handleError);
  }

  simulationParticipant(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/get`, data ).toPromise()
      .catch(this.handleError);
  }

  simulationDelete(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/delete`, data ).toPromise()
      .catch(this.handleError);
  }

  simulationStart(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/start`, data ).toPromise()
      .catch(this.handleError);
  }

  simulationAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/user/add`, data ).toPromise()
      .catch(this.handleError);
  }

  simulationUserAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/user/get`, data ).toPromise()
      .catch(this.handleError);
  }

  getSimulationUserDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}simulation/user/details/get`, data ).toPromise()
      .catch(this.handleError);
  }

  addSheetCases(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/cases/add`, data ).toPromise()
      .catch(this.handleError);
  }

  getSheetCases(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/cases/get`, data ).toPromise()
      .catch(this.handleError);
  }

  updateSheetCases(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/cases/update`, data ).toPromise()
      .catch(this.handleError);
  }
  deleteSheetCases(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/cases/delete`, data ).toPromise()
      .catch(this.handleError);
  }

  addSheet(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/add`, data ).toPromise()
      .catch(this.handleError);
  }

  getSheet(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/get`, data ).toPromise()
      .catch(this.handleError);
  }

  updateSheet(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/update`, data ).toPromise()
      .catch(this.handleError);
  }
  deleteSheet(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/delete`, data ).toPromise()
      .catch(this.handleError);
  }
  addSheetDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/details/add`, data ).toPromise()
      .catch(this.handleError);
  }

  getSheetDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/details/get`, data ).toPromise()
      .catch(this.handleError);
  }

  updateSheetDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/details/update`, data ).toPromise()
      .catch(this.handleError);
  }
  deleteSheetDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/details/delete`, data ).toPromise()
      .catch(this.handleError);
  }

  attachSheetPivot(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/pivot/attach`, data ).toPromise()
      .catch(this.handleError);
  }

  detachSheetPivot(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/pivot/detach`, data ).toPromise()
      .catch(this.handleError);
  }

  addSheetAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/answer/add`, data ).toPromise()
      .catch(this.handleError);
  }

  getSheetAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/answer/get`, data ).toPromise()
      .catch(this.handleError);
  }

  updateSheetAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}sheet/answer/update`, data ).toPromise()
      .catch(this.handleError);
  }

  addAnatomy(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/add`, data ).toPromise()
      .catch(this.handleError);
  }

  updateAnatomy(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/update`, data ).toPromise()
      .catch(this.handleError);
  }

  deleteAnatomy(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/delete`, data ).toPromise()
      .catch(this.handleError);
  }

  getAnatomy(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/get`, data ).toPromise()
      .catch(this.handleError);
  }

  getAnatomyDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/get/details`, data ).toPromise()
      .catch(this.handleError);
  }

  getAnatomyAnswers(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/get/answers`, data ).toPromise()
      .catch(this.handleError);
  }

  getAnatomyAnswerDetails(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/get/answers/details`, data ).toPromise()
      .catch(this.handleError);
  }

  addAnatomyAnswer(data: any): Promise<any> {
    return this.http.post<any>(`${this.baseUrl}anatomy/add/answers`, data ).toPromise()
      .catch(this.handleError);
  }

  getVideoMaterials(): Promise<any> {
    const url = `${this.baseUrl}video-materials`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  getVideoStreaming(url: string): Promise<Blob> {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .catch(error => {
        console.error('Error fetching video stream:', error);
        throw error;
      });
  }

  getVideoMaterial(id: number): Promise<any> {
    const url = `${this.baseUrl}video-materials/${id}`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  addVideoMaterial(data: any): Promise<any> {
    const url = `${this.baseUrl}video-materials`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  updateVideoMaterial(data: any): Promise<any> {
    const url = `${this.baseUrl}video-materials/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  deleteVideoMaterial(data: any): Promise<any> {
    const url = `${this.baseUrl}video-materials/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  getAdminKategori(): Promise<any> {
    const url = `${this.baseUrl}admin/kategori/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  private getFreeclassApiUrl(): string {
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      return 'http://localhost:8000/api/';
    }
    return 'https://oscemediko.id/api/';
  }

  getArticles(kategori?: string, id?: number | string): Promise<any> {
    if (id) {
      const url = `${this.getFreeclassApiUrl()}articles/${id}`;
      return this.http.get<any>(url).toPromise()
        .then((res: any) => {
          const item = res?.data || res;
          return { data: item ? [item] : [] };
        })
        .catch((error: any) => {
          if (error && (error.status === 404 || error.status === 204)) {
            return { data: [], message: 'Data tidak ditemukan', status: error.status };
          }
          return this.handleError(error);
        });
    }

    let params = new HttpParams();
    if (kategori) params = params.set('category', kategori);

    const url = `${this.getFreeclassApiUrl()}articles`;
    return this.http.get<any>(url, { params }).toPromise()
      .then((res: any) => {
        return { data: res?.data || [] };
      })
      .catch((error: any) => {
        if (error && (error.status === 404 || error.status === 204)) {
          return { data: [], message: 'Data tidak ditemukan', status: error.status };
        }
        return this.handleError(error);
      });
  }

  addArticle(data: FormData): Promise<any> {
    const url = `${this.baseUrl}article/add`;
    return this.http.post(url, data, { responseType: 'text' }).toPromise()
      .then(text => {
        try {
          return JSON.parse(text as string);
        } catch (e) {
          return { message: 'success', data: text };
        }
      })
      .catch(this.handleError);
  }

  updateArticle(data: FormData): Promise<any> {
    const url = `${this.baseUrl}article/update`;
    return this.http.post(url, data, { responseType: 'text' }).toPromise()
      .then(text => {
        try {
          return JSON.parse(text as string);
        } catch (e) {
          return { message: 'success', data: text };
        }
      })
      .catch(this.handleError);
  }

  deleteArticle(data: any): Promise<any> {
    const url = `${this.baseUrl}article/delete`;
    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  processAllVideos(): Promise<any> {
    const url = 'https://api.oscemediko.id/process-all-videos';

    return this.http.post<any>(url, {}).toPromise()
      .catch(this.handleError);
  }

  getVideoProcessingLogs(): Promise<any> {
    const url = 'https://api.oscemediko.id/logs/web';

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  getVideoProcessingStats(): Promise<any> {
    const url = 'https://api.oscemediko.id/logs/stats';

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  checkVideoProcessingHealth(): Promise<any> {
    const url = 'https://api.oscemediko.id/health';

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  addNotes(data: any): Promise<any> {
    const url = `${this.baseUrl}notes/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  updateNotes(data: any): Promise<any> {
    const url = `${this.baseUrl}notes/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  getNotes(userId: string): Promise<any> {
    const url = `${this.baseUrl}notes/get`;

    return this.http.post<any>(url, { USER_ID: userId }).toPromise()
      .catch(this.handleError);
  }

  deleteNotes(data: any): Promise<any> {
    const url = `${this.baseUrl}notes/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  getTestimonyVideos(): Promise<any> {
    const url = `${this.baseUrl}testimony_video/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  addTestimonyVideo(data: any): Promise<any> {
    const url = `${this.baseUrl}testimony_video/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  updateTestimonyVideo(data: any): Promise<any> {
    const url = `${this.baseUrl}testimony_video/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  deleteTestimonyVideo(data: any): Promise<any> {
    const url = `${this.baseUrl}testimony_video/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  getTestimonyImages(): Promise<any> {
    const url = `${this.baseUrl}testimony_image/get`;

    return this.http.get<any>(url).toPromise()
      .catch(this.handleError);
  }

  addTestimonyImage(data: FormData): Promise<any> {
    const url = `${this.baseUrl}testimony_image/add`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  updateTestimonyImage(data: FormData): Promise<any> {
    const url = `${this.baseUrl}testimony_image/update`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  deleteTestimonyImage(data: any): Promise<any> {
    const url = `${this.baseUrl}testimony_image/delete`;

    return this.http.post<any>(url, data).toPromise()
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse): Promise<never> {
    return Promise.reject(error || error);
  }
}
